// Text for the student, user and lesson view pages and the profile tabs.
// Merged in I18nContext as `record`. {name} is replaced by the component.
export const recordStrings = {
  ar: {
    personal: "التفاصيل الشخصية",
    lessons: "الدروس",
    guide: "المرشد المسؤول",
    students: "قائمة الطلاب",
    lessonDetails: "تفاصيل الدرس",
    myDetails: "تفاصيلي",
    myStudents: "طلابي",
    myLessons: "دروسي",
    theirStudents: "طلابه",
    theirLessons: "دروسه",
    noLessons: "لا يوجد دروس بعد",
    noGuide: "لا يوجد مرشد مسؤول بعد",
    attendance: "الحضور",
    noAttendance: "لا يوجد حضور مسجّل بعد",
    deletedLesson: "درس محذوف",
    attendanceMonth: "الشهر",
    allMonths: "كل الأشهر",
    attendanceRate: "نسبة الحضور",
    signOutAll: "تسجيل الخروج من كل الأجهزة",
    signOutAllConfirm: "سيُطلب منه تسجيل الدخول من جديد على كل جهاز. متابعة؟",
    signedOutAll: "تم تسجيل خروجه من كل الأجهزة",
    signOutAllFailed: "تعذّر تسجيل الخروج",
    edit: "تعديل",
    print: "طباعة الملف",
    removeConfirm: "إزالة {name} من الدرس؟",
    delete: "حذف",
    deleteAccount: "حذف الحساب",
    deleted: "تم الحذف بنجاح",
    deleteFailed: "تعذّر الحذف",
    suspend: "إيقاف الحساب",
    suspendConfirm: "سيُنقل الحساب إلى الحسابات الموقوفة ولن يتمكن صاحبه من الدخول. متابعة؟",
    suspended: "تم إيقاف الحساب بنجاح",
    suspendFailed: "تعذّر إيقاف الحساب",
    status: "الحالة",
    approve: "قبول",
    reject: "رفض",
    approvedStudent: "تم قبول الطالب بنجاح",
    approveFailed: "تعذّر القبول",
    activate: "تفعيل",
    activated: "تم التفعيل بنجاح",
    activateFailed: "تعذّر التفعيل",
    waiting: "بانتظار الموافقة",
    suspendedState: "موقوف",
    // A user who is also in the IT department (owner, 2026-11-03).
    itDepartment: "قسم IT",
    itDepartmentNote: "من قسم IT أيضًا: لا يمكن إيقافه أو حذفه هنا، ويمكن تعديل بياناته الشخصية وطلابه فقط.",
    itDetailsOnly: "هذا المستخدم من قسم IT: يمكن تعديل بياناته الشخصية فقط، بدون كلمة المرور والبريد الإلكتروني والدور.",
  },
};
